<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20.6 13.5H3.4q-.6 0-1-.4T2 12t.4-1 1-.5h17.2q.6 0 1 .4T22 12t-.4 1-1 .5"
    />
  </svg>
</template>
